<template>
  <CRow>
    <CCol>
      <CCard>
        <CCardHeader>Edit Data Event & Tips</CCardHeader>
        <CCardBody>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                id="title"
                label="Title"
                class="mb-0"
                type="text"
                required
                horizontal
                placeholder="Title"
                v-model.trim="corporateActionHashtagData.corporate_action_hashtag_title"
                @change="handleCorporateActionHashtagTitle"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <div role="group" class="form-group form-row mb-0">
                <label class="col-form-label col-sm-3">Page</label>
                <div class="col-sm-9">
                  <multiselect
                    horizontal
                    v-model="corporateActionHashtagData.corporate_action_hashtag_page_array"
                    :options="OptionPage"
                    :multiple="true"
                    placeholder="Select Page"
                  />
                </div>
              </div>
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CSelect
                label="Status"
                :options="optionsStatus"
                required
                horizontal
                v-model="corporateActionHashtagData.status"
                @change="handleCorporateActionHashtagStatus"
              />
            </CCol>
          </CRow>
        </CCardBody>
        <CCardFooter>
          <CRow>
            <CCol sm="5">
              <CButton color="primary" @click="goBack">Back</CButton>
            </CCol>
            <CCol sm="7" class="d-none d-md-block">
              <CButton
                color="success"
                class="float-right"
                @click="updateCorporateAction"
                >Submit</CButton
              >
            </CCol>
          </CRow>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
// import usersData from './UsersData'
import axios from "axios";
import Swal from "sweetalert2";
import moment from "moment";
import jwt from "jsonwebtoken";
import Multiselect from 'vue-multiselect';

export default {
  name: "CorporateActionHashtagEdit",
  components: {
    Multiselect,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.usersOpened = from.fullPath.includes("usercreate");
    });
  },
  data() {
    return {
      corporateActionHashtagData: {
        corporate_action_hashtag_page_array: []
      },
      OptionPage: ['Ongkir'],
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token"),
      optionsStatus: ["ACTIVE", "INACTIVE"],
      url: null,
    };
  },
  mounted() {
    this.authentication();
    this.getDataByID();
  },
  methods: {
    getDataByID() {
      let CorporateActionHashtagID = this.$route.params.id;
      console.log(CorporateActionHashtagID)
      axios
        .get(`${this.domain}/v1/corporate_action_hashtag/data/${CorporateActionHashtagID}`, {
          headers: {
            Authorization: this.token,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          // JSON responses are automatically parsed.
          console.log(response);
          this.corporateActionHashtagData = {
            ...response.data,
            corporate_action_hashtag_page_array: response.data.corporate_action_hashtag_page || []
          };
        })
        .catch((e) => {
          console.log(e);
        });
    },
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
        data.account_group === "MARKETING" ||
        data.account_group === "ADMIN" ||
        data.account_group === "ADMINISTRATOR"
      ) {
        return null;
      } else {
        this.$router.push({ path: `/` });
      }
    },
    goBack() {
      this.usersOpened
        ? this.$router.go(-1)
        : this.$router.push({ path: "/management/corporate-hashtag" });
    },
    handleCorporateActionHashtagTitle(event) {
      var hashtag = event.replaceAll(/[^A-Za-z0-9]/g,'').replaceAll('#','').replaceAll(' ','').replaceAll('--','').trim();
      document.getElementById('title').value = hashtag;
      this.corporateActionHashtagData.corporate_action_hashtag_title = hashtag;
    },
    handleCorporateActionHashtagStatus(event) {
      console.log(event.target.value)
      this.corporateActionHashtagData.status = event.target.value;
    },
    updateCorporateAction() {
      let CorporateActionID = this.$route.params.id;
      let formData = new FormData();
      formData.append(
        "corporate_action_hashtag_title",
        this.corporateActionHashtagData.corporate_action_hashtag_title
      );
      if (this.corporateActionHashtagData.corporate_action_hashtag_page_array && this.corporateActionHashtagData.corporate_action_hashtag_page_array.length > 0) {
        const joined = this.corporateActionHashtagData.corporate_action_hashtag_page_array.join(',');
        formData.append("corporate_action_hashtag_page", joined);
      }
      formData.append("status", this.corporateActionHashtagData.status);
      axios
        .put(
          `${this.domain}/v1/corporate_action_hashtag/update/${CorporateActionID}`,
          formData,
          {
            headers: {
              Authorization: this.token,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          // JSON responses are automatically parsed.
          Swal.fire({
            icon: "success",
            title: `Event & Tips Hashtag Data Updated`,
            showConfirmButton: false,
            timer: 2000,
          });
          this.items = response.data;
          //this.$router.push({ path: `/management/corporate` });
        })
        .catch((err) => {
          this.corporateActionDataNew.active_date = moment(
            String(this.corporateActionDataNew.active_date)
          ).format("YYYY-MM-DD");
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: err.response.data.message.id,
          });
        });
    },
  },
  validator(val) {
    return val ? val.length >= 4 : false;
  },
};
</script>

<style scoped>
@import "./CorporateHashtag.css";
</style>
